import {
  MemberProfileExtendedType,
  VALID_PEOPLE_ENTITIES,
} from 'common/types/MemberProfile'
import { ImportantFootnote } from '../../common/ImportantFootnote'
import { InformationBadges } from './InformationBadges'
import React from 'react'

const InformationItem = ({ name }: { name: string }) => (
  <p className='text-sm text-[#405985]'>{name}</p>
)

interface ProfessionalCoreProps {
  profile: MemberProfileExtendedType
}

const ProfessionalCoreSection = ({
  title,
  items,
}: {
  title: string
  items: string[] | undefined
}) => (
  <div>
    <h4 className='font-medium text-base text-[#093269]'>{title}</h4>
    <div className='flex flex-col gap-2 pt-2'>
      {(!items || items.length === 0) &&
        InformationItem({ name: 'Not provided' })}
      {items?.map((name: string) => InformationItem({ name }))}
    </div>
  </div>
)

export const ProfessionalCore = ({ profile }: ProfessionalCoreProps) => {
  return (
    <div className='flex flex-col gap-6 p-10'>
      <InformationBadges profile={profile} />
      {VALID_PEOPLE_ENTITIES.includes(profile.memberEntity) ? (
        <>
          <ProfessionalCoreSection
            title='Academic qualifications:'
            items={profile.professional_core.academic_qualifications}
          />
          <ProfessionalCoreSection
            title='Memberships:'
            items={profile.professional_core.memberships}
          />
        </>
      ) : (
        <ProfessionalCoreSection
          title='Accreditations:'
          items={profile.professional_core.accreditations}
        />
      )}
      <ImportantFootnote
        className='text-[10px]'
        text='None of the information in the above section has been reviewed or verified by Legal Utopia.'
      />
    </div>
  )
}
